var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelopeAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 3.1665H3.33325C2.80282 3.1665 2.29411 3.37722 1.91904 3.75229C1.54397 4.12736 1.33325 4.63607 1.33325 5.1665V11.8332C1.33325 12.3636 1.54397 12.8723 1.91904 13.2474C2.29411 13.6225 2.80282 13.8332 3.33325 13.8332H12.6666C13.197 13.8332 13.7057 13.6225 14.0808 13.2474C14.4559 12.8723 14.6666 12.3636 14.6666 11.8332V5.1665C14.6666 4.63607 14.4559 4.12736 14.0808 3.75229C13.7057 3.37722 13.197 3.1665 12.6666 3.1665ZM3.33325 4.49984H12.6666C12.8434 4.49984 13.013 4.57008 13.138 4.6951C13.263 4.82012 13.3333 4.98969 13.3333 5.1665L7.99992 8.41984L2.66659 5.1665C2.66659 4.98969 2.73682 4.82012 2.86185 4.6951C2.98687 4.57008 3.15644 4.49984 3.33325 4.49984ZM13.3333 11.8332C13.3333 12.01 13.263 12.1796 13.138 12.3046C13.013 12.4296 12.8434 12.4998 12.6666 12.4998H3.33325C3.15644 12.4998 2.98687 12.4296 2.86185 12.3046C2.73682 12.1796 2.66659 12.01 2.66659 11.8332V6.6865L7.65325 9.73317C7.7546 9.79168 7.86956 9.82249 7.98659 9.82249C8.10361 9.82249 8.21857 9.79168 8.31992 9.73317L13.3333 6.6865V11.8332Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeAlt);
export default __webpack_public_path__ + "static/media/envelope-alt.006b48e4c9d55f9f056acd07fb7878b2.svg";
export { ForwardRef as ReactComponent };